import {
  CUSTOMER_ACCOUNT,
  FBP_MANAGEMENT_ACCOUNTS,
  FBP_MANAGEMENT_ACCOUNT_DETAILS,
  FBP_ACCOUNT_REGION_DETAILS,
  FBP_CONFIGURE,
  FBP_SERVICE_SCAN,
} from "../../config/service";

import {
  getfbpAccountRegionDetails,
  getfbpManagementAccounts,
  getfbpManagementAccountDetails,
} from "../factories";
import { setFbpConfiguration } from "../factories/fbp";

export const setUpFBPServices = (mock) => {
  const _getFbpManagementAccount = new RegExp(
    `${CUSTOMER_ACCOUNT}${FBP_MANAGEMENT_ACCOUNTS}`
  );

  mock.onGet(_getFbpManagementAccount).reply((config) => {
    let managementAccounts = getfbpManagementAccounts();
    return [200, managementAccounts];
  });

  const getFbpManagementAccountDetails = new RegExp(
    `${FBP_MANAGEMENT_ACCOUNT_DETAILS}.+`
  );

  mock.onGet(getFbpManagementAccountDetails).reply((config) => {
    let managementAccountDetails = getfbpManagementAccountDetails();
    return [200, managementAccountDetails];
  });

  const _getfbpAccountRegionDetails = new RegExp(
    `${FBP_ACCOUNT_REGION_DETAILS}.+`
  );

  mock.onGet(_getfbpAccountRegionDetails).reply((config) => {
    let managementAccountRegionDetails = getfbpAccountRegionDetails();
    return [200, managementAccountRegionDetails];
  });

  const configureFbp = new RegExp(`${FBP_CONFIGURE}`);

  mock.onPost(configureFbp).reply((config) => {
    const { data } = config;
    setFbpConfiguration(JSON.parse(data));
    return [200, { FbpWorkloadId: "test" }];
  });

  const scanFbp = new RegExp(`${FBP_SERVICE_SCAN}`);

  mock.onPost(scanFbp).reply((config) => {
    return [200, { FbpWorkloadId: "test" }];
  });
};
